export const DATE_FORMAT = {
  DISPLAY_YYYYMMDD: 'yyyy/MM/dd',
  DISPLAY_YYYYMMDDE: 'yyyy/MM/dd (E)',
}

export const ALTAIR_START_YEAR = 2015 // Altairの開始年
